export default [
    {
        path: '/',
        meta: {},
        component: () => import('@/views/8/index')
    },
    {
        path: '/clerk/info',
        meta: {
            // title: '我的资料'
            menuName:'我的资料',
            menuPermission:'info'
        },
        component: () => import('@/views/8/clerk/info')
    },

]
